<div class="page-header flex flex-row px-4 py-2 gap-2">
  <div class="flex-1 bm-breadcrumbs text-sm">
    <ul class="m-0 p-0">
      <li>
        <a [routerLink]="['/']">Home</a>
      </li>
      <li>
        <a [routerLink]="['/', 'lager']"> <i class="fa fa-building-o"></i> Lager </a>
      </li>
      <li>
        <a [routerLink]="['/', 'lager', 'uebersicht']"> Übersicht </a>
      </li>
      <li>
        <a>
          @if (warehouse) {
            {{ warehouse.label }}
          } @else {
            ...
          }
        </a>
      </li>
    </ul>
  </div>
  @if (false) {
  <a target="_blank" href="/warehouse/warehouse/{{ warehouseId }}/edit" class="bm-btn bm-btn-ghost">
    <i class="fa fa-pencil"></i>
    Bearbeiten
  </a>
  }
  <div class="bm-join">
    <a
      href="/warehouse/warehouse/{{ warehouseId }}/exportMaterial"
      class="bm-join-item bm-btn bm-btn-ghost"
      target="_blank"
    >
      <i class="fa fa-download"></i>Material-Export
    </a>
    <a
      [routerLink]="['/', 'lager', warehouseId, 'retoure_international']"
      class="bm-join-item bm-btn bm-btn-ghost"
      target="_blank"
    >
      <i class="fas fa-warehouse-alt"></i> Int. Retoure anlegen
    </a>
    <button (click)="onDelete()" class="bm-join-item bm-btn bm-btn-primary" [disabled]="!canDelete">
      <i class="fas fa-trash-alt"></i>Lager deaktivieren
    </button>
  </div>
</div>

<div class="page-content px-4 pb-2 grid grid-cols-1 gap-2" style="grid-template-rows: auto auto 1fr">
  <div class="flex-1 flex flex-col gap-3">
    <div class="page-sheet flex flex-col md:flex-row flex-wrap w-full gap-4">
      <section class="bm-card bm-card-border border-base-300 flex-1 max-w-1/5">
        <div class="bm-card-body">
          <div class="bm-card-title bm-card-title-top bg-base-100" (click)="editLabel = !editLabel">Stammdaten</div>
          @if (warehouse) {
            <ng-container [ngTemplateOutlet]="tplStammdaten" />
          }
        </div>
      </section>

      <div class="flex flex-col gap-4 flex-1 max-w-1/5">
        <section class="bm-card bm-card-border border-base-300">
          <div class="bm-card-body">
            <div class="bm-card-title bm-card-title-top bg-base-100">Beschränkung der Artikelvorlagen</div>
            @if (warehouse) {
              <ng-container [ngTemplateOutlet]="tplVorlagen" />
            }
          </div>
        </section>

        <section class="bm-card bm-card-border border-base-300 flex-1">
          <div class="bm-card-body">
            <div class="bm-card-title bm-card-title-top bg-base-100 flex flex-row justify-between items-center">
              Versand-E-Mails
              @if (warehouse) {
                <button class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost" (click)="openNotificationEmailsDialog()">
                  <fa-icon [icon]="['far', 'edit']" />
                </button>
              }
            </div>
            @if (warehouse) {
              <ng-container [ngTemplateOutlet]="tplNotificationEmails" />
            }
          </div>
        </section>
      </div>

      <section class="bm-card bm-card-border border-base-300 flex-1 max-w-1/5">
        <div class="bm-card-body">
          <div class="bm-card-title bm-card-title-top bg-base-100">Inventurdaten</div>
          @if (warehouse) {
            <ng-container [ngTemplateOutlet]="tplStocktake" />
          }
        </div>
      </section>

      <section class="bm-card bm-card-border border-base-300 flex-1 max-w-1/5">
        <div class="bm-card-body">
          <div class="bm-card-title bm-card-title-top bg-base-100">Adresse</div>
          @if (warehouse) {
            <ng-container [ngTemplateOutlet]="tplAddress" />
          }
        </div>
      </section>

      <section class="bm-card bm-card-border border-base-300 flex-1 max-w-1/5">
        <div class="bm-card-body p-0">
          <div
            class="bm-card-title bm-card-title-top bg-base-100 ml-3 px-1 bg-base-100 rounded z-2"
            style="line-height: 1.2"
          >
            Karte
          </div>
          @if (warehouse) {
            <ng-container [ngTemplateOutlet]="tplMap" />
          }
        </div>
      </section>
    </div>
  </div>

  <div class="flex flex-row items-center">
    <label>Lagerplätze</label>
    <div class="flex-1"></div>
    <button [disabled]="isAddingStorage" (click)="addStorage()" class="bm-btn bm-btn-ghost">
      <i class="fa fa-plus-circle"></i>
      Neuer Lagerplatz
    </button>
  </div>
  <ag-grid-angular
    class="ag-theme-quartz w-full h-full"
    [theme]="hawkTheme"
    [loadThemeGoogleFonts]="true"
    [rowData]="storageBins"
    [defaultColDef]="defaultColDef"
    [getRowId]="getRowId"
    [columnDefs]="colDefs"
    [rowClassRules]="rowClassRules"
    [localeText]="locale"
    [rowSelection]="rowSelection"
    (suppressClickEdit)="(false)"
    (rowEditingStopped)="onRowEditingStopped($event)"
    (cellValueChanged)="onCellValueChanged($event)"
    (gridReady)="onGridReady($event)"
  />
</div>

<ng-template #tplStammdaten>
  @if (editLabel) {
    <hawk-shared-edit-input
      [textValue]="warehouse.label"
      [modus]="'text'"
      (saveClicked)="saveLabel($event)"
      (cancelClicked)="editLabel = false"
    />
  } @else {
    <div [innerHtml]="warehouse.label" (click)="toggleLabel()"></div>
  }
  <dl class="bm-dl gap-x-2">
    <dt>Artikel</dt>
    <dd>
      <a class="g-link d-flex gap-2" [routerLink]="['/', 'lager', warehouseId, 'articles']">
        <i class="fa fa-cube mr6"></i>{{ warehouse.articles_count }}
      </a>
    </dd>
    <dt>Bad parts</dt>
    <dd>
      <a class="g-link d-flex gap-2" [routerLink]="['/', 'lager', warehouseId, 'bad-parts']">
        <i class="fa fa-bug mr6"></i>{{ warehouse.bad_parts_count }}
      </a>
    </dd>
    <dt (click)="editTechnician = !editTechnician">Techniker</dt>
    <dd>
      @if (editTechnician) {
        <hawk-shared-edit-input
          [selectValue]="warehouse.owner_id"
          [selectOptions]="technicians"
          [modus]="'select'"
          (saveClicked)="saveTechnician($event)"
          (cancelClicked)="editTechnician = false"
        />
      } @else {
        <a class="g-link d-flex gap-2" href="/a/benutzer/{{ warehouse.owner_id }}" *ngIf="warehouse.owner_id">
          <i class="fa fa-user mr6" aria-hidden="true"></i>{{ warehouse.owner }}
        </a>
        @if (!warehouse.owner_id) {
          -
        }
      }
    </dd>
    <dt (click)="editTelephone = !editTelephone">Telefon</dt>
    <dd>
      @if (editTelephone) {
        <hawk-shared-edit-input
          [textValue]="warehouse.telephone"
          [modus]="'text'"
          (saveClicked)="saveTelephone($event)"
          (cancelClicked)="editTelephone = false"
        />
      } @else {
        {{ warehouse.telephone }}
      }
    </dd>

    <dt (click)="editMainWarehouse = !editMainWarehouse">Hauptlager</dt>
    <dd>
      @if (editMainWarehouse) {
        <hawk-shared-edit-input
          [boolValue]="warehouse.main_warehouse"
          [modus]="'checkbox'"
          (saveClicked)="saveMainWarehouse($event)"
          (cancelClicked)="editMainWarehouse = false"
        />
      } @else if (warehouse.main_warehouse) {
        <fa-icon [icon]="['far', 'check']" />
      } @else {
        <fa-icon [icon]="['far', 'times']" />
      }
    </dd>

    <dt (click)="editFreeFill = !editFreeFill">Free fill</dt>
    <dd>
      @if (editFreeFill) {
        <hawk-shared-edit-input
          [boolValue]="warehouse.freefill"
          [modus]="'checkbox'"
          (saveClicked)="saveFreeFill($event)"
          (cancelClicked)="editFreeFill = false"
        />
      } @else if (warehouse.freefill) {
        <fa-icon [icon]="['far', 'check']" />
      } @else {
        <fa-icon [icon]="['far', 'times']" />
      }
    </dd>

  </dl>
</ng-template>

<ng-template #tplVorlagen>
  <dl class="bm-dl gap-x-2">
    <dt (click)="editLimitTemplate1 = !editLimitTemplate1">Kommentar 1</dt>
    <dd>
      @if (editLimitTemplate1) {
        <hawk-shared-edit-input
          [textValue]="warehouse.limit_template1"
          [modus]="'text'"
          (saveClicked)="saveLimitTemplate1($event)"
          (cancelClicked)="editLimitTemplate1 = false"
        />
      } @else {
        {{ warehouse.limit_template1 || "-" }}
      }
    </dd>

    <dt (click)="editLimitTemplate2 = !editLimitTemplate2">Kommentar 2</dt>
    <dd>
      @if (editLimitTemplate2) {
        <hawk-shared-edit-input
          [textValue]="warehouse.limit_template2"
          [modus]="'text'"
          (saveClicked)="saveLimitTemplate1($event)"
          (cancelClicked)="editLimitTemplate2 = false"
        />
      } @else {
        {{ warehouse.limit_template2 || "-" }}
      }
    </dd>

    <dt (click)="editLimitTemplate3 = !editLimitTemplate3">Kommentar 3</dt>
    <dd>
      @if (editLimitTemplate3) {
        <hawk-shared-edit-input
          [textValue]="warehouse.limit_template3"
          [modus]="'text'"
          (saveClicked)="saveLimitTemplate1($event)"
          (cancelClicked)="editLimitTemplate3 = false"
        />
      } @else {
        {{ warehouse.limit_template3 || "-" }}
      }
    </dd>
  </dl>
</ng-template>

<ng-template #tplNotificationEmails>
  @if (warehouse.delivery_notification_emails) {
    <div class="flex flex-wrap gap-1" [class.text-xs]="warehouse.delivery_notification_emails.split(',').length > 6">
      @for (email of warehouse.delivery_notification_emails.split(','); track $index) {
        <a href="mailto:{{ email.trim() }}" class="badge badge-neutral badge-sm hover:badge-primary transition-colors">{{ email.trim() }}</a>
      }
    </div>
  } @else {
    <span class="text-sm opacity-50">Keine E-Mails konfiguriert</span>
  }
</ng-template>

<ng-template #tplStocktake>
  <dl class="bm-dl gap-x-2">

    <dt>Aktuelle Inventur</dt>
    @if (warehouse.stocktake_secret && warehouse.stocktake_valid_until) {
      <dd>Bis {{ warehouse.stocktake_valid_until | date: "dd.MM.yy HH:mm" }}</dd>
      <div class="col-span-2 flex flex-wrap gap-1">
        <button class="bm-btn bm-btn-xs" (click)="openExtendStocktakeDialog()">Verlängern</button>
        <button class="bm-btn bm-btn-xs bm-btn-error" (click)="confirmDeleteStocktake()">Löschen</button>
      </div>

      <dt>
        Techniker Link
        <fa-icon [icon]="faInfoCircle" [tooltip]="'Über diesen Link kann der Techniker die Inventur durchführen'"></fa-icon>
      </dt>
      @if (Date.parse(warehouse.stocktake_valid_until) > Date.now()) {
        <dd>
          <a class="bm-link" [routerLink]="['/lager', warehouse.id, 'inventur', warehouse.stocktake_secret, 'start']" target="_blank">Zur Inventur</a>
        </dd>
        <div class="col-span-2 flex flex-wrap gap-1">
          <button class="bm-btn bm-btn-xs"
                  (click)="copyStocktakeTechnicianLink()">
            @if (stocktakeLinkCopied()) { ✓ Kopiert } @else { Link kopieren }
          </button>
          <button class="bm-btn bm-btn-xs"
                  (click)="openBinSelectDialog()">
            Lagerplatz Link
          </button>
        </div>
      } @else {
        <dd class="text-error">ABGELAUFEN</dd>
      }
    } @else {
      <dd>Nicht vorhanden</dd>
      <div class="col-span-2 flex">
        <button class="bm-btn bm-btn-xs" (click)="openStartStocktakeDialog()">Erstellen</button>
      </div>
    }

    <dt>Letzte Inventur</dt>
    @if (warehouse.stocktake_data) {
      <dd>{{ warehouse.stocktake_data.date_finished | date: "dd.MM.yy HH:mm" }}</dd>
      <div class="col-span-2 flex">
        <button class="bm-btn bm-btn-xs"
                [class.bm-btn-disabled]="downloadingStocktakeExcel"
                (click)="downloadExcel(warehouse)">
          @if (!downloadingStocktakeExcel) { Excel herunterladen } @else { Lädt… }
        </button>
      </div>
    } @else {
      <dd>Keine Daten</dd>
    }

  </dl>
</ng-template>

<ng-template #tplAddress>
  <dl class="bm-dl gap-x-2">
    <dt (click)="editCompany = !editCompany">Firma</dt>
    <dd>
      @if (editCompany) {
        <hawk-shared-edit-input
          [textValue]="warehouse.address_company"
          [modus]="'text'"
          (saveClicked)="saveCompany($event)"
          (cancelClicked)="editCompany = false"
        />
      } @else {
        {{ warehouse.address_company || "-" }}
      }
    </dd>

    <dt (click)="editName = !editName">Name</dt>
    <dd>
      @if (editName) {
        <fieldset class="bm-fieldset">

          <label class="bm-label">Vorname</label>
          <input class="bm-input bm-input-sm bm-join-item"
            type="text"
            [(ngModel)]="addressFirstName"
            (keydown.esc)="editName = false"
            (keydown.enter)="saveName()"
          />

          <label class="bm-label">Nachname</label>
          <input class="bm-input bm-input-sm bm-join-item"
            type="text"
            [(ngModel)]="addressLastName"
            (keydown.esc)="editName = false"
            (keydown.enter)="saveName()"
          />

          <span>
            <button class="me-1" (click)="saveName()"><fa-icon [icon]="['far', 'save']" /></button>
            <button (click)="editName = false"><fa-icon [icon]="['far', 'times']" /></button>
          </span>
        </fieldset>
      } @else {
        {{ warehouse.address_firstname }} {{ warehouse.address_lastname }}
      }
    </dd>

    <dt (click)="editStreet = !editStreet">Straße</dt>
    <dd>
      @if (editStreet) {
        <hawk-shared-edit-input
          [textValue]="warehouse.address_street"
          [modus]="'text'"
          (saveClicked)="saveStreet($event)"
          (cancelClicked)="editStreet = false"
        />
      } @else {
        {{ warehouse.address_street || "-" }}
      }
    </dd>

    <dt (click)="editZipcode = !editZipcode">PLZ/Ort</dt>
    <dd>
      @if (editZipcode) {
        <fieldset class="bm-fieldset">

          <label class="bm-label">PLZ</label>
          <input class="bm-input bm-input-sm bm-join-item"
            type="text"
            [(ngModel)]="addressZip"
            (keydown.esc)="editZipcode = false"
            (keydown.enter)="saveZipcode()"
          />

          <label class="bm-label">Ort</label>
          <input class="bm-input bm-input-sm bm-join-item"
            type="text"
            [(ngModel)]="addressCity"
            (keydown.esc)="editZipcode = false"
            (keydown.enter)="saveZipcode()"
          />

          <span>
            <button class="me-1" (click)="saveZipcode()"><fa-icon [icon]="['far', 'save']"></fa-icon></button>
            <button (click)="editZipcode = false"><fa-icon [icon]="['far', 'times']"></fa-icon></button>
          </span>
        </fieldset>
      } @else {
        {{ warehouse.address_zip }} {{ warehouse.address_city }}
      }
    </dd>

    <dt (click)="editCountry = !editCountry">Land</dt>
    <dd>
      @if (editCountry) {
        <fieldset class="bm-fieldset">

          <label class="bm-label">Land</label>
          <input class="bm-input bm-input-sm bm-join-item"
            type="text"
            [(ngModel)]="addressCountry"
            (keydown.esc)="editCountry = false"
            (keydown.enter)="saveCountry()"
          />

          <label class="bm-label">Bundesland</label>
          <input class="bm-input bm-input-sm bm-join-item"
            type="text"
            [(ngModel)]="addressState"
            (keydown.esc)="editCountry = false"
            (keydown.enter)="saveCountry()"
          />

          <span>
            <button class="me-1" (click)="saveCountry()"><fa-icon [icon]="['far', 'save']"></fa-icon></button>
            <button (click)="editCountry = false"><fa-icon [icon]="['far', 'times']"></fa-icon></button>
          </span>
        </fieldset>
      } @else {
        {{ warehouse.address_country }} ({{ warehouse.address_state }})
      }
    </dd>
  </dl>
</ng-template>

<ng-template #tplMap>
  <mgl-map [style]="'mapbox://styles/mapbox/streets-v9'" [zoom]="[11]" [center]="position" class="w-full aspect-video">
    @for (marker of markerData; track $index) {
      <mgl-marker *ngIf="marker.lat && marker.lng" [lngLat]="[marker.lng, marker.lat]">
        <div
          class="marker"
          [style.borderColor]="'black'"
          [style.backgroundColor]="marker.color"
          title="{{ marker.text }}"
        ></div>
      </mgl-marker>
    }
  </mgl-map>
</ng-template>

@if (startStocktakeDlgOpen()) {
  <dialog class="bm-modal" open>
    <div class="bm-modal-box">
      <div class="bm-card-title mb-2">Inventur starten</div>

      <div class="bm-tabs bm-tabs-box mb-3">
        <button class="bm-tab"
                [class.bm-tab-active]="startStocktakeMode()==='days'"
                (click)="startStocktakeMode.set('days')">Dauer (Tage)</button>
        <button class="bm-tab"
                [class.bm-tab-active]="startStocktakeMode()==='date'"
                (click)="startStocktakeMode.set('date')">Enddatum</button>
      </div>

      @if (startStocktakeMode()==='days') {
        <label class="bm-input">
          <span class="bm-label w-40">Gültig für</span>
          <input type="number" min="1" class="grow w-24"
                 [value]="startStocktakeDays()"
                 (input)="startStocktakeDays.set(+$any($event.target).value || 7)" />
          <span class="bm-label">Tage</span>
        </label>
        <div class="text-xs opacity-70 mt-1">
          Standard: 7 Tage. Mindestdauer 1 Tag.
        </div>
      } @else {
        <label class="bm-input">
          <span class="bm-label w-40">Ende</span>
          <input type="datetime-local" class="grow"
                 [value]="startStocktakeDateLocal()"
                 (input)="startStocktakeDateLocal.set($any($event.target).value)" />
        </label>
        <div class="text-xs opacity-70 mt-1">
          Wir berechnen intern die Tage bis zu diesem Datum (aufgerundet).
        </div>
      }

      <div class="bm-modal-action mt-4">
        <button class="bm-btn bm-btn-ghost" (click)="startStocktakeDlgOpen.set(false)">Abbrechen</button>
        <button class="bm-btn bm-btn-primary" (click)="confirmStartStocktake()">Starten</button>
      </div>
    </div>
  </dialog>
}

@if (extendStocktakeDlgOpen()) {
  <dialog class="bm-modal" open>
    <div class="bm-modal-box">
      <div class="bm-card-title mb-2">Inventur verlängern</div>

      <label class="bm-input">
        <span class="bm-label w-40">Neues Enddatum</span>
        <input type="datetime-local" class="grow"
               [value]="extendStocktakeDateLocal()"
               (input)="extendStocktakeDateLocal.set($any($event.target).value)" />
      </label>
      <div class="text-xs opacity-70 mt-1">
        Muss in der Zukunft liegen.
      </div>

      <div class="bm-modal-action mt-4">
        <button class="bm-btn bm-btn-ghost" (click)="extendStocktakeDlgOpen.set(false)">Abbrechen</button>
        <button class="bm-btn bm-btn-primary" (click)="confirmExtendStocktake()">Übernehmen</button>
      </div>
    </div>
  </dialog>
}

@if (binSelectDialogOpen()) {
  <dialog class="bm-modal" open>
    <div class="bm-modal-box">
      <div class="bm-card-title mb-2">Inventur-Link für bestimmte Lagerplätze</div>

      <div class="text-sm opacity-70 mb-3">
        Wähle die Lagerplätze aus, die der Techniker inventarisieren soll.
      </div>

      @if (storageBins && storageBins.length > 0) {
        <div class="flex flex-col gap-2 max-h-[50vh] overflow-y-auto">
          @for (bin of storageBins; track bin.id) {
            <label class="flex items-center gap-2 cursor-pointer p-1 rounded hover:bg-base-200">
              <input type="checkbox"
                     class="checkbox checkbox-sm"
                     [checked]="selectedBinIds().has(bin.id)"
                     (change)="toggleBinSelection(bin.id)" />
              <span>{{ bin.name }}</span>
            </label>
          }
        </div>
      } @else {
        <div class="text-sm opacity-70">Keine Lagerplätze vorhanden.</div>
      }

      @if (filteredStocktakeUrl()) {
        <div class="mt-3 p-2 bg-base-200 rounded text-xs break-all select-all">
          {{ filteredStocktakeUrl() }}
        </div>
      }

      <div class="bm-modal-action mt-4">
        <button class="bm-btn bm-btn-ghost" (click)="binSelectDialogOpen.set(false)">Abbrechen</button>
        <button class="bm-btn bm-btn-primary"
                [disabled]="selectedBinIds().size === 0"
                (click)="copyFilteredStocktakeLink()">
          @if (filteredLinkCopied()) { ✓ Link kopiert } @else { Link kopieren }
        </button>
      </div>
    </div>
  </dialog>
}

@if (notificationEmailsDialogOpen()) {
  <dialog class="bm-modal" open>
    <div class="bm-modal-box">
      <h3 class="text-lg font-bold mb-4">Versand-E-Mails bearbeiten</h3>
      <p class="text-sm opacity-70 mb-4">
        E-Mail-Adressen, die bei Lieferschein-Erstellung in der Lager-App automatisch vorausgefüllt werden.
      </p>

      <div class="flex flex-col gap-2">
        @for (email of notificationEmailInputs; track $index) {
          <div class="flex items-center gap-2">
            <input
              type="email"
              class="bm-input bm-input-sm flex-1"
              [class.border-error]="notificationEmailErrors[$index]"
              [ngModel]="notificationEmailInputs[$index]"
              (ngModelChange)="notificationEmailInputs[$index] = $event; validateNotificationEmail($index)"
              placeholder="email@beispiel.de"
            />
            @if (notificationEmailInputs.length > 1) {
              <button
                type="button"
                class="bm-btn bm-btn-sm bm-btn-square bm-btn-ghost text-error"
                (click)="removeNotificationEmailInput($index)"
              >
                <fa-icon [icon]="['far', 'times']" />
              </button>
            }
          </div>
          @if (notificationEmailErrors[$index]) {
            <p class="text-xs text-error -mt-1 ml-1">Ungültige E-Mail-Adresse</p>
          }
        }
      </div>

      <button
        type="button"
        class="bm-btn bm-btn-sm bm-btn-ghost mt-2"
        (click)="addNotificationEmailInput()"
      >
        <i class="fa fa-plus"></i> Weitere E-Mail
      </button>

      <div class="bm-modal-action mt-4">
        <button class="bm-btn bm-btn-ghost" (click)="notificationEmailsDialogOpen.set(false)">Abbrechen</button>
        <button
          class="bm-btn bm-btn-primary"
          [disabled]="!canSaveNotificationEmails"
          (click)="saveNotificationEmails()"
        >
          Speichern
        </button>
      </div>
    </div>
  </dialog>
}

